// apiSlice.ts
import {  createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from './ChatSlice';


export const clinicalTrialssApi = createApi({
    reducerPath: 'clinicalTrialsApi',
    baseQuery: baseQueryWithReauth,//fetchBaseQuery(),
    tagTypes: ['CLINICAL_TRIAL', 'CLINICAL_TRIAL_LIST'],
    endpoints: (builder) => ({
        //gest profile  by iam_is inserts if no matching profile found        
        getClinicalTrials: builder.query<any[], {condition: string, asofDate?: Date, trialPhase?: string[], addlConditions?: string[] | undefined }>({
            query: ({condition, asofDate, trialPhase, addlConditions}) => {
                const params = new URLSearchParams();
                params.append('condition', condition);
                if (asofDate) {
                    params.append('asofDate', asofDate.toISOString().split('T')[0]);
                }
                // if (trialPhase && trialPhase.length > 0) {
                //     trialPhase.forEach(phase => params.append('trialPhase', phase));
                // }
                return {
                    url: `/api/clinicaltrials/search/?${params.toString()}`,
                    method: 'POST',
                    ...((trialPhase && trialPhase.length > 0) || addlConditions)? {body: {...trialPhase?.length?{trialPhase}:{}, ...addlConditions?{addlConditions}:{} }}:{}
                };
            },
            providesTags: (result, response, updated) => {
                return ['CLINICAL_TRIAL_LIST']
            }
        }),
        getClinicalTrialsById: builder.query<any,  string>({
            query: (nciId) => {
                const qry = `/api/clinicaltrials/?nciId=${nciId}`                
                return qry
            },
            providesTags: (result, response, updated) => {
                 return [{ type: 'CLINICAL_TRIAL', id: result?.nciId}]
             }
        }),
    }),
})


export const { useGetClinicalTrialsQuery, useGetClinicalTrialsByIdQuery } = clinicalTrialssApi
